// extracted by mini-css-extract-plugin
module.exports = {"language":"Language_language__38OdU"};